<template>
    <div class="slide">
        <!-- 轮播图 -->
        <el-carousel :interval="4000"  height="500px" trigger="click" width="100%" >
            <el-carousel-item v-for="(item, index) in options" :key="index">
                <img  :src="item.src"  />
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
export default {
    name:'SlideShow',
    data() {
        return {
            options: [
                {src:require('@/assets/img/solid1.png')},
                {src:require('@/assets/img/solid2.png')},
                {src:require('@/assets/img/solid3.png')},
                {src:require('@/assets/img/solid4.png')},
                {src:require('@/assets/img/solid5.png')},
                {src:require('@/assets/img/solid6.png')},
            ]
        }
    },
    
    methods: {
        
    }

}
</script>

<style scoped>
el-carousel {
    width: 100%;
    height: 500px;
}
.slide img{
    width: 100%;
    height: 500px;
    margin-top: 20px;
}


</style>